import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closePrivilegeModal } from '../../Store/Slices/privilegeSlice';
import AddPrivilege from './AddPrivilege';
import EditPrivilege from './EditPrivilege';
import DeletePrivilege from './DeletePrivilege';
import { useState } from 'react';
import { useEffect } from 'react';

const PrivilegeDialog = () => {

    const dispatch = useDispatch();
    const privilege = useSelector((state) => state.privilege);
    const [roles, setRoles] = useState("")

    useEffect(() => {
      const getRoles = () => {
        if (typeof window !== undefined) {
          setRoles(sessionStorage.getItem("role"));
        }
      }
      getRoles()
    }, [])

    let content;
    let deleteView = false

    const handleClose = () => {
      dispatch(closePrivilegeModal(false))
    }

    if (privilege.modalStatus === "add") {
      content = roles?.split(",").includes("PRIV_ECOM_ADDPRIVILEGE") && <AddPrivilege handleClose={() => handleClose()} />;
    } else if (privilege.modalStatus === "edit") {
      content = roles?.split(",").includes("PRIV_ECOM_EDITPRIVILEGE") && <EditPrivilege handleClose={() => handleClose()} />;
    } else if (privilege.modalStatus === "delete") {
      deleteView = true
      content = roles?.split(",").includes("PRIV_ECOM_DELETEPRIVILEGE") && <DeletePrivilege/>;
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                sx={{
                  marginLeft: deleteView ? '25rem' : '15rem',
                  marginRight: deleteView ? '25rem' : '15rem',
                  maxWidth: deleteView ? 'fit-content' : 'none'
                }}
                open={privilege.modalStatus === "add" || privilege.modalStatus === "edit" || privilege.modalStatus === "delete"}
            >
                <DialogContent>{content}</DialogContent>
            </Dialog>
        </>
    )
}

export default PrivilegeDialog